import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Header";
import Dashboard from "../pages/Dashboard";
import UserManagement from "../pages/UserManagement";
import MembershipManagement from "../pages/MembershipManagement";
import DietPlanManagement from "../pages/DietPlanManagement";
import ExerciseManagement from "../pages/ExerciseManagement";
import AddUser from "../pages/AddUser";
import RenewalAlerts from "../pages/RenewalAlerts";
import EditMembership from "../pages/EditMembership";
import EditExercise from "../pages/EditExercise";
import EditDiet from "../pages/EditDiet";
import EditUser from "../pages/EditUser";
import GSTInvoiceandAgreement from "../pages/GSTInvoiceandAgreement";
import TrainerManagement from "../pages/TrainerManagement";
import BookingManagement from "../pages/BookingManagement";
import AddTrainer from "../pages/AddTrainer";
import BookingSettings from "../pages/BookingSettings";
import UserByTrainer from "../pages/UserByTrainer";
import NotificationManagement from "../pages/NotificationManagement";
import EditNotification from "../pages/EditNotification";
import Settings from "../pages/Settings";
import PostManagement from "../pages/PostManagement";
import Profile from "../pages/Profile";
import Logout from "../pages/Logout";
import TermsAndCondition from "../pages/TermsAndCondition";
import ViewDetails from "../pages/ViewDetails";

const Content = () => {
  return (
    <div
      style={{
        width: "78%",
        minHeight: "100vh",
        marginLeft: "22%",
        boxSizing: "border-box",
        backgroundColor: "var(--bodycolor)",
      }}
    >
      <Header />
      <Routes>
        <Route path="/admin/overview" element={<Dashboard />} />
        <Route path="/admin/usermanagement" element={<UserManagement />} />
        <Route path="/admin/usermanagement/adduser" element={<AddUser />} />
        <Route
          path="/admin/usermanagement/edituser/:id"
          element={<EditUser />}
        />
        <Route
          path="/admin/membershipmanagement"
          element={<MembershipManagement />}
        />
        <Route
          path="/admin/membershipmanagement/viewdetail"
          element={<ViewDetails />}
        />
        <Route
          path="/admin/membershipmanagement/renewalalerts"
          element={<RenewalAlerts />}
        />
        <Route
          path="/admin/membershipmanagement/editmembership/:id"
          element={<EditMembership />}
        />
        <Route
          path="/admin/dietplanmanagement"
          element={<DietPlanManagement />}
        />
        <Route
          path="/admin/dietplanmanagement/editdiet/:id"
          element={<EditDiet />}
        />
        <Route
          path="/admin/exercisemanagement"
          element={<ExerciseManagement />}
        />
        <Route
          path="/admin/exercisemanagement/editexercise/:id"
          element={<EditExercise />}
        />
        <Route
          path="/admin/gstinvoicemanagement"
          element={<GSTInvoiceandAgreement />}
        />
        <Route
          path="/admin/trainermanagement"
          element={<TrainerManagement />}
        />
        <Route
          path="/admin/trainermanagement/addtrainer"
          element={<AddTrainer />}
        />
        <Route
          path="/admin/trainermanagement/:trainerId"
          element={<UserByTrainer />}
        />
        <Route
          path="/admin/bookingmanagement"
          element={<BookingManagement />}
        />
        <Route
          path="/admin/bookingmanagement/settings"
          element={<BookingSettings />}
        />
        <Route path="/admin/postmanagement" element={<PostManagement />} />
        <Route
          path="/admin/notificationmanagement"
          element={<NotificationManagement />}
        />
        <Route
          path="/admin/termsandconditions"
          element={<TermsAndCondition />}
        />

        <Route
          path="/admin/notificationmanagement/:id"
          element={<EditNotification />}
        />
        <Route path="/admin/settings" element={<Settings />} />
        <Route path="/admin/profile" element={<Profile />} />
        <Route path="/admin/logout" element={<Logout />} />
      </Routes>
    </div>
  );
};

export default Content;
